import {ConflictingFilesList} from '../../conflicts/ConflictingFilesList'
import {Status} from '../../../../helpers/merge-box-status-calculator/stacks-merge-conflicts-and-rebase-section-status'
import type {StacksMergeConflictsAndRebaseSectionProps} from '../types'
import {ResolveConflictsButtonAndDialog} from './shared/ResolveConflictsButtonAndDialog'
import {useId} from 'react'
import {AlertIcon} from '../../common/AlertIcon'
import {MergeBoxSectionHeader} from '../../common/MergeBoxSectionHeader'

/**
 * Scenario: the CURRENT entry has merge conflicts. Lists the conflicting files and
 * points the viewer at the command line to resolve them.
 */
export function CurrentEntryMergeConflicts({
  status,
  conflicts,
  stackMetadata,
}: StacksMergeConflictsAndRebaseSectionProps) {
  const headerId = useId()

  if (status !== Status.CurrentEntryStackMergeConflicts) return null

  return (
    <section
      aria-label="Current stack entry merge conflicts"
      className="border-bottom borderColor-muted"
      aria-describedby={headerId}
    >
      <div className="d-flex flex-column width-full overflow-hidden">
        <MergeBoxSectionHeader
          headerId={headerId}
          icon={<AlertIcon />}
          title="This branch has conflicts that must be resolved"
          subtitle="Use the command line to resolve conflicts within the stack before continuing."
          rightSideContent={<ResolveConflictsButtonAndDialog stackNumber={stackMetadata?.number ?? 0} />}
        >
          <ConflictingFilesList conflicts={conflicts} className="tmp-ml-n3" />
        </MergeBoxSectionHeader>
      </div>
    </section>
  )
}
